import { ethers } from 'ethers';

// MultiSig Treasury Smart Contract Address on BSC (Binance Smart Chain)
export const TREASURY_CONTRACT_ADDRESS = '0xDeE8F6B47E38Ba74392C56559555fB7014FB446f';

// BSC Network Parameters
export const BSC_CHAIN_ID_DECIMAL = 56;
export const BSC_CHAIN_ID_HEX = '0x38';
export const BSC_RPC_URLS = [
  'https://bsc-dataseed.binance.org/',
  'https://bsc-dataseed1.defibit.io/',
  'https://binance.llamarpc.com'
];
export const BSC_EXPLORER_URL = 'https://bscscan.com';

// Standard BSC USDT Token Address for quick test/verification
export const BSC_USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';

// Neo MarcLife (NMRC) BEP20 Token Address on BSC
export const BSC_NMRC_ADDRESS = '0x2643815F6603e2b3803D3e6f82706CC13B484a1f';

// Complete MultiSigTreasury Contract ABI
export const TREASURY_ABI = [
  // State view functions
  'function deployer() view returns (address)',
  'function owners(uint256) view returns (address)',
  'function isOwner(address) view returns (bool)',
  'function requiredConfirmations() view returns (uint256)',
  'function transactionCount() view returns (uint256)',
  'function isConfirmed(uint256, address) view returns (bool)',
  'function getOwners() view returns (address[])',
  'function getTransactionCount() view returns (uint256)',
  'function getTransaction(uint256 _txId) view returns (address to, uint256 value, address token, uint256 tokenAmount, bytes data, bool executed, uint256 numConfirmations)',
  'function getBNBBalance() view returns (uint256)',
  'function getTokenBalance(address _token) view returns (uint256)',

  // Owner Write functions
  'function submitTransaction(address _to, uint256 _value, bytes memory _data) public returns (uint256 txId)',
  'function submitTokenTransaction(address _to, address _token, uint256 _tokenAmount, bytes memory _data) public returns (uint256 txId)',
  'function confirmTransaction(uint256 _txId) public',
  'function revokeConfirmation(uint256 _txId) public',
  'function executeTransaction(uint256 _txId) public',

  // Deployer Write functions
  'function addOwner(address _owner) public',
  'function removeOwner(address _owner) public',
  'function changeRequirement(uint256 _required) public',
  'function changeDeployer(address _newDeployer) public',

  // Events
  'event Deposit(address indexed sender, uint256 amount, uint256 balance)',
  'event SubmitTransaction(address indexed owner, uint256 indexed txId, address to, uint256 value, address token, uint256 tokenAmount)',
  'event ConfirmTransaction(address indexed owner, uint256 indexed txId)',
  'event RevokeConfirmation(address indexed owner, uint256 indexed txId)',
  'event ExecuteTransaction(address indexed owner, uint256 indexed txId)',
  'event OwnerAdded(address indexed owner)',
  'event OwnerRemoved(address indexed owner)',
  'event RequirementChanged(uint256 required)',
  'event DeployerChanged(address indexed oldDeployer, address indexed newDeployer)'
];

// Minimal standard ERC20 ABI for balance checks & details
export const ERC20_ABI = [
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function balanceOf(address account) view returns (uint256)',
  'function transfer(address to, uint256 amount) returns (bool)'
];

// Create read-only fallback provider
export const getFallbackProvider = () => {
  return new ethers.JsonRpcProvider(BSC_RPC_URLS[0]);
};

// Get Read-only Contract instance (no wallet required)
export const getReadOnlyTreasuryContract = () => {
  const provider = getFallbackProvider();
  return new ethers.Contract(TREASURY_CONTRACT_ADDRESS, TREASURY_ABI, provider);
};

// Get Write Contract instance with Signer
export const getWriteTreasuryContract = (signer) => {
  return new ethers.Contract(TREASURY_CONTRACT_ADDRESS, TREASURY_ABI, signer);
};

// Switch network in MetaMask/browser wallet to BSC Mainnet
export const switchWalletToBsc = async () => {
  if (!window.ethereum) {
    throw new Error('No Web3 wallet found. Please install MetaMask, Trust Wallet, or another BSC compatible wallet.');
  }

  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: BSC_CHAIN_ID_HEX }],
    });
    return true;
  } catch (switchError) {
    // 4902 error code indicates that the chain has not been added to MetaMask
    if (switchError.code === 4902) {
      try {
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: BSC_CHAIN_ID_HEX,
              chainName: 'BNB Smart Chain Mainnet',
              nativeCurrency: {
                name: 'BNB',
                symbol: 'BNB',
                decimals: 18,
              },
              rpcUrls: BSC_RPC_URLS,
              blockExplorerUrls: [BSC_EXPLORER_URL],
            },
          ],
        });
        return true;
      } catch (addError) {
        throw new Error('Failed to add BNB Smart Chain to wallet: ' + (addError.message || addError));
      }
    }
    throw switchError;
  }
};
